import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { EnumStatusConsultation } from "../../interfaces/history";

type Props = {
    show: boolean;
    onHide: () => void;
    protocol?: string;
    currentStatus?: number;
    onConfirm: (status: EnumStatusConsultation) => void;
    loading?: boolean;
};

const STATUS_OPTIONS: { value: EnumStatusConsultation; label: string }[] = [
    { value: EnumStatusConsultation.approved, label: "Aprovado" },
    { value: EnumStatusConsultation.disapproved, label: "Reprovado" },
    { value: EnumStatusConsultation.inProcess, label: "Em processo" },
    { value: EnumStatusConsultation.completed, label: "Finalizado" },
    { value: EnumStatusConsultation.inAnalyzing, label: "Em análise" },
];

const ChangeCnpjStatusModal: React.FC<Props> = ({
    show,
    onHide,
    protocol,
    currentStatus = EnumStatusConsultation.inAnalyzing,
    onConfirm,
    loading,
}) => {
    const [status, setStatus] = React.useState<number>(currentStatus);

    React.useEffect(() => setStatus(currentStatus), [currentStatus, show]);

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Alterar status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-2">
                    <small className="text-muted">Protocolo</small>
                    <div><strong>{protocol || "—"}</strong></div>
                </div>
                <Form.Group controlId="statusSelect">
                    <Form.Label>Novo status</Form.Label>
                    <Form.Select
                        value={status}
                        onChange={(e) => setStatus(Number(e.target.value))}
                        disabled={loading}
                    >
                        {STATUS_OPTIONS.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={loading}>
                    Cancelar
                </Button>
                <Button
                    variant="primary"
                    onClick={() => onConfirm(status as EnumStatusConsultation)}
                    disabled={loading}
                >
                    {loading ? "Salvando..." : "Salvar"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ChangeCnpjStatusModal;